export const navigation = [{
  name: 'Calendario',
  url: '/calendario',
  icon: 'icon-calendar',
  roles: ['administrador', 'asesor']
},
// {
//   name: 'Catalogos',
//   url: '/catalogo',
//   icon: 'icon-star',
//   roles: ['administrador'],
//   children: [
//     {
//       name: 'Presencia de Marca',
//       url: '/catalogo/articulos-marca',
//       icon: 'icon-puzzle',
//       roles: ['administrador']
//     },
//     {
//       name: 'Clasificaciones',
//       url: '/catalogo/clasificaciones',
//       icon: 'icon-puzzle',
//       roles: ['administrador']
//     },
//     {
//       name: "Giros",
//       url: '/catalogo/giros-clientes',
//       icon: 'icon-puzzle',
//       roles: ['administrador']
//     },
//     {
//       name: "Ocupaciones",
//       url: '/catalogo/ocupaciones',
//       icon: 'icon-puzzle',
//       roles: ['administrador']
//     },
//     {
//       name: "Contactado En ",
//       url: '/catalogo/contactado-en',
//       icon: 'icon-puzzle',
//       roles: ['administrador']
//     }, {
//       name: "Productos",
//       url: '/catalogo/productos',
//       icon: 'icon-puzzle',
//       roles: ['administrador', 'asesor', 'MAYORISTAMINORISTA']
//     }, {
//       name: "Produtos Comparativa",
//       url: '/catalogo/productos-comparativa',
//       icon: 'icon-puzzle',
//       roles: ['administrador']
//     }, {
//       name: "Produtos Comparativa Minorista",
//       url: '/catalogo/productos-comparativa-minorista',
//       icon: 'icon-puzzle',
//       roles: ['administrador']
//     }, {
//       name: "Tipos Clientes",
//       url: '/catalogo/tipos-clientes',
//       icon: 'icon-puzzle',
//       roles: ['administrador']
//     }, {
//       name: "Tipos de Contacto",
//       url: '/catalogo/tipos-contacto',
//       icon: 'icon-puzzle',
//       roles: ['administrador']
//     }, {
//       name: "Tipos de Obra",
//       url: '/catalogo/tipos-obra',
//       icon: 'icon-puzzle',
//       roles: ['administrador']
//     }, {
//       name: "Tipos de Venta",
//       url: '/catalogo/tipos-venta',
//       icon: 'icon-puzzle',
//       roles: ['administrador']
//     }, {
//       name: "asesores",
//       url: '/catalogo/asesores',
//       icon: 'icon-puzzle',
//       roles: ['administrador']
//     }, {
//       name: "asesores Ciudades",
//       url: '/catalogo/asesores-ciudades',
//       icon: 'icon-puzzle',
//       roles: ['administrador']
//     },
//     {
//       name: "Potencial Contactos",
//       url: '/catalogo/potenciales-contactos',
//       icon: 'icon-puzzle',
//       roles: ['administrador']
//     },
//     {
//       name: "Rutas",
//       url: '/catalogo/rutas-minoristas',
//       icon: 'icon-puzzle',
//       roles: ['administrador', 'MINORISTA', 'MAYORISTAMINORISTA']
//     },
//     {
//       name: "Tiendas HD",
//       url: '/catalogo/tiendas-homedepot',
//       icon: 'icon-puzzle',
//       roles: ['administrador', 'asesor', 'MAYORISTAMINORISTA']
//     },
//     {
//       name: "Articulos Promocionales",
//       url: '/catalogo/articulos-promocionales',
//       icon: 'icon-puzzle',
//       roles: ['administrador']
//     },
//     {
//       name: "Marcas Competencia HD",
//       url: '/catalogo/marcas-competencia',
//       icon: 'icon-puzzle',
//       roles: ['administrador', 'asesor', 'MAYORISTAMINORISTA']
//     },
//     {
//       name: "SKUs Competencia HD",
//       url: '/catalogo/skus-competencia',
//       icon: 'icon-puzzle',
//       roles: ['administrador', 'asesor', 'MAYORISTAMINORISTA']
//     },
//     {
//       name: "Tipos Tuberia",
//       url: '/catalogo/tipos-tuberia',
//       icon: 'icon-puzzle',
//       roles: ['administrador', 'asesor', 'MAYORISTAMINORISTA']
//     },
//     {
//       name: "Compañías de Teléfono",
//       url: '/catalogo/companias-telefono',
//       icon: 'icon-puzzle',
//       roles: ['administrador']
//     },
//     {
//       name: "Tipos Flyer",
//       url: '/catalogo/tipos-flyer',
//       icon: 'icon-puzzle',
//       roles: ['administrador']
//     }

//   ]
// },
{
  title: 'true',
  name: 'Administración',
  roles: ['administrador']
},
{
  name: 'Catalogos',
  url: '/catalogo',
  icon: 'icon-star',
  roles: ['administrador'],
  children: [
    {
      name: 'Regiones',
      url: '/catalogo/regiones',
      icon: 'icon-puzzle',
      roles: ['administrador']
    },
    {
      name: 'Distritos',
      url: '/catalogo/distritos',
      icon: 'icon-puzzle',
      roles: ['administrador']
    },
    {
      name: 'Tiendas Chedrahui',
      url: '/catalogo/tiendas-chedraui',
      icon: 'icon-puzzle',
      roles: ['administrador']
    },
    {
      name: 'Asesores',
      url: '/catalogo/asesores',
      icon: 'icon-puzzle',
      roles: ['administrador']
    },
     {
      name: "Lineas",
      url: '/catalogo/lineas',
      icon: 'icon-puzzle',
      roles: ['administrador', 'asesor', 'MAYORISTAMINORISTA']
    },
    {
      name: "Productos",
      url: '/catalogo/productos',
      icon: 'icon-puzzle',
      roles: ['administrador', 'asesor', 'MAYORISTAMINORISTA']
    },
    {
      name: 'Medios Contacto',
      url: '/prospectos/catalogos/cat_medios_contacto_prospectos/Medios',
      icon: 'icon-puzzle',
      roles: ['administrador']
    },
    {
      name: 'Razon Pérdida',
      url: '/prospectos/catalogos/cat_razones_perdida_prospectos/Razones',
      icon: 'icon-puzzle',
      roles: ['administrador']
    },
    {
      name: 'Actividades',
      url: '/prospectos/catalogos/cat_actividades_prospectos/Actividades',
      icon: 'icon-puzzle',
      roles: ['administrador']
    },
    {
      name: 'Interés Visita',
      url: '/prospectos/catalogos/cat_interes_visita/Interes',
      icon: 'icon-puzzle',
      roles: ['administrador']
    },
    {
      name: 'Periodos compra',
      url: '/prospectos/catalogos/cat_periodos_compra/Perdiodos de Compra',
      icon: 'icon-puzzle',
      roles: ['administrador']
    },
    {
      name: 'Tipos Visita',
      url: '/prospectos/catalogos/cat_tipos_visitas/Tipos Visita',
      icon: 'icon-puzzle',
      roles: ['administrador']
    },
    {
      name: 'Volumenes compra',
      url: '/prospectos/catalogos/cat_volumenes_compra/Volumenes Compra',
      icon: 'icon-puzzle',
      roles: ['administrador']
    },
    {
      name: 'Tamaños Empresas',
      url: '/prospectos/catalogos/cat_tamano_empresas/Tamaños Empresas',
      icon: 'icon-puzzle',
      roles: ['administrador']
    },
    {
      name: 'Razones Contacto',
      url: '/prospectos/catalogos/cat_razones_contacto/Razones Contacto',
      icon: 'icon-puzzle',
      roles: ['administrador']
    },
    {
      name: 'Aplicaciones Bolsa',
      url: '/prospectos/catalogos/cat_aplicaciones_bolsa/Aplicaciones Bolsa',
      icon: 'icon-puzzle',
      roles: ['administrador']
    },
    {
      name: 'Pigmentos',
      url: '/prospectos/catalogos/cat_pigmentos/Pigmentos',
      icon: 'icon-puzzle',
      roles: ['administrador']
    },
    {
      name: 'Densidades',
      url: '/prospectos/catalogos/cat_densidad_bolsas/Densidades Bolsa',
      icon: 'icon-puzzle',
      roles: ['administrador']
    },


  ]
},
{
  name: 'Usuarios',
  url: '/usuarios',
  icon: 'icon-star',
  roles: ['administrador'],
  children: [
    {
      name: 'Catalogo',
      url: '/usuarios',
      icon: 'icon-puzzle',
      roles: ['administrador']
    },
  ]
},
{
  title: 'true',
  name: 'Operación'
},
{
  name: 'Clientes',
  url: '/visitas',
  icon: 'icon-star',
  roles: ['administrador', 'asesor'],
  children: [
    {
      name: 'Alta Visita',
      url: '/visitas/mayoristas/add',
      icon: 'icon-puzzle',
      roles: ['administrador', 'asesor', 'MAYORISTAMINORISTA', 'MINORISTA', 'MAYORISTAMINORISTA']
    },
    {
      name: 'Listado Visita',
      url: '/visitas/mayoristas/list',
      icon: 'icon-puzzle',
      roles: ['administrador', 'asesor', 'MAYORISTAMINORISTA', 'MINORISTA', 'MAYORISTAMINORISTA']
    },
    {
      name: "Resumen Ejecutivo",
      url: '/visitas/mayoristas/resumen-ejecutivo',
      icon: 'icon-puzzle',
      roles: ['administrador', 'asesor', 'MAYORISTAMINORISTA', 'MINORISTA', 'MAYORISTAMINORISTA']
    },
    {
      name: "Resumen de Participación",
      url: '/visitas/mayoristas/resumen-participacion',
      icon: 'icon-puzzle',
      roles: ['administrador', 'asesor', 'MAYORISTAMINORISTA', 'MINORISTA', 'MAYORISTAMINORISTA']
    },
    {
      name: "Resumen Plan VS Real",
      url: '/visitas/mayoristas/programacion-vs-real',
      icon: 'icon-puzzle',
      roles: ['administrador', 'asesor', 'MAYORISTAMINORISTA']
    },
    {
      name: "Clientes",
      url: '/visitas/mayoristas/clientes',
      icon: 'icon-puzzle',
      roles: ['administrador', 'asesor', 'MAYORISTAMINORISTA']
    },
    // {
    //   name: "Mapa de rutas",
    //   url: '/visitas/mayoristas/mapa',
    //   icon: 'icon-puzzle',
    //   roles: ['administrador', 'asesor', 'MAYORISTAMINORISTA', 'MINORISTA', 'MAYORISTAMINORISTA']
    // }
  ]
},
{
  name: 'Reuniones Clientes',
  url: '/reuniones',
  icon: 'icon-star',
  roles: ['administrador', 'asesor', 'MAYORISTAMINORISTA'],
  children: [
    {
      name: 'Listado de minutas',
      url: '/reuniones/minutas-list',
      icon: 'icon-puzzle',
      roles: ['administrador', 'asesor', 'MAYORISTAMINORISTA']
    },
    {
      name: 'Acuerdos Minutas',
      url: '/reuniones/acuerdos-minutas-list',
      icon: 'icon-puzzle',
      roles: ['administrador', 'asesor', 'MAYORISTAMINORISTA']
    },
    // {
    //   name: 'Resumen Acuerdos Minutas',
    //   url: '/reuniones/resumen-acuerdos-minutas',
    //   icon: 'icon-puzzle',
    //   roles: ['administrador', 'asesor', 'MAYORISTAMINORISTA']
    // },
    // {
    //   name: 'Estructura comercial',
    //   url: '/reuniones/estructura-comercial',
    //   icon: 'icon-puzzle',
    //   roles: ['administrador', 'asesor', 'MAYORISTAMINORISTA']
    // },
    // {
    //   name: 'Pláticas Mayoristas',
    //   url: '/reuniones/platicas-mayoristas-list',
    //   icon: 'icon-puzzle',
    //   roles: ['administrador', 'asesor', 'MAYORISTAMINORISTA']
    // },
    // {
    //   name: 'Reuniones Vendedores Mayoristas',
    //   url: '/reuniones/reunion-vendedores-mayoristas-list',
    //   icon: 'icon-puzzle',
    //   roles: ['administrador', 'asesor', 'MAYORISTAMINORISTA']
    // },
    // {
    //   name: 'Reunion Vendedores Distribuidor',
    //   url: '/reuniones/reunion-vendedores-distribuidor-list',
    //   icon: 'icon-puzzle',
    //   roles: ['administrador', 'asesor', 'MAYORISTAMINORISTA']
    // },
    // {
    //   name: 'Seguimiento Promociones',
    //   url: '/reuniones/seguimiento-promociones-list',
    //   icon: 'icon-puzzle',
    //   roles: ['administrador', 'asesor', 'MAYORISTAMINORISTA']
    // },
  ]
},
{
  name: 'Chedraui',
  url: '/chedraui',
  icon: 'icon-star',
  roles: ['administrador', 'asesor', 'MAYORISTAMINORISTA'],
  children: [
    {
      name: 'Programacion Visitas',
      url: '/chedraui/programacion',
      icon: 'icon-puzzle',
      roles: ['administrador', 'asesor', 'MAYORISTAMINORISTA']
    },
    {
      name: 'Visitas Realizadas',
      url: '/chedraui/chedraui-list',
      icon: 'icon-puzzle',
      roles: ['administrador', 'asesor', 'MAYORISTAMINORISTA']
    },
    {
      name: 'Reporte Ejecutivo',
      url: '/chedraui/reporte-ejecutivo-chedraui',
      icon: 'icon-puzzle',
      roles: ['administrador', 'asesor', 'MAYORISTAMINORISTA']
    },
    {
      name: 'Reporte Plan Vs Real',
      url: '/chedraui/reporte-plan-vs-real',
      icon: 'icon-puzzle',
      roles: ['administrador', 'asesor', 'MAYORISTAMINORISTA']
    }
  ]
},
{
  name: 'Formatos dinámicos',
  url: '/formatos-dinamicos',
  icon: 'icon-star',
  roles: ['administrador'],
  children: [
    {
      name: 'Formatos Dinámicos',
      url: '/formatos-dinamicos/list',
      icon: 'icon-puzzle',
      roles: ['administrador']
    },
     {
      name: "Resultados Formatos",
      url: '/formatos-dinamicos/resultados',
      icon: 'icon-puzzle',
      roles: ['administrador', 'asesor', 'MAYORISTAMINORISTA', 'MINORISTA', 'MAYORISTAMINORISTA', 'SEGUIMIENTO']
    }
  ]

},
{
  title: 'true',
  name: 'Prospectos',
  roles: ['administrador', 'asesor', 'MAYORISTAMINORISTA'],
},
{
  name: 'Tablero',
  url: '/prospectos/dashboard',
  icon: 'icon-star',
  roles: ['administrador', 'asesor', 'MAYORISTAMINORISTA'],
  // children: [
  //   {
  //     name: 'Regiones',
  //     url: '/prospectos/dashboard',
  //     icon: 'icon-puzzle',
  //     roles: ['administrador', 'asesor', 'MAYORISTAMINORISTA'],
  //   }
  // ]
},
{
  name: 'Acuerdos',
  url: '/prospectos/acuerdos',
  icon: 'icon-star',
  roles: ['administrador', 'asesor', 'MAYORISTAMINORISTA'],
  children: [
    {
      name: 'Listado',
      url: '/prospectos/acuerdos/acuerdos-minutas-list',
      icon: 'icon-puzzle',
      roles: ['administrador', 'asesor', 'MAYORISTAMINORISTA']
    },
    {
      name: 'Resumen Semanal',
      url: '/reuniones/resumen-acuerdos-minutas',
      icon: 'icon-puzzle',
      roles: ['administrador', 'asesor', 'MAYORISTAMINORISTA']
    },
  ]
},
{
  name: 'Reportes',
  url: '/prospectos/reportes',
  icon: 'icon-star',
  roles: ['administrador', 'asesor', 'MAYORISTAMINORISTA'],
  children: [
    {
      name: 'Asesor',
      url: '/prospectos/reportes/asesor',
      icon: 'icon-puzzle',
      roles: ['administrador', 'asesor', 'MAYORISTAMINORISTA']
    },
    {
      name: 'Perdida',
      url: '/prospectos/reportes/perdida',
      icon: 'icon-puzzle',
      roles: ['administrador', 'asesor', 'MAYORISTAMINORISTA']
    },
    {
      name: 'Metricas',
      url: '/prospectos/reportes/metricas',
      icon: 'icon-puzzle',
      roles: ['administrador', 'asesor', 'MAYORISTAMINORISTA']
    },
    {
      name: 'Visitas Plan vs Real',
      url: '/prospectos/reportes/visitas-plan-vs-real',
      icon: 'icon-puzzle',
      roles: ['administrador', 'asesor', 'MAYORISTAMINORISTA']
    },
    {
      name: 'Presupuesto',
      url: '/prospectos/reportes/presupuesto',
      icon: 'icon-puzzle',
      roles: ['administrador', 'asesor', 'MAYORISTAMINORISTA']
    }
  ]
},
// {
//   name: 'Distribuidores',
//   url: '/reuniones',
//   icon: 'icon-star',
//   roles: ['administrador', 'asesor', 'MAYORISTAMINORISTA'],
//   children: [
//     {
//       name: 'Reunion Vendedores Distribuidor',
//       url: '/reuniones/reunion-vendedores-distribuidor-list',
//       icon: 'icon-puzzle',
//       roles: ['administrador', 'asesor', 'MAYORISTAMINORISTA']
//     },
//     {
//       name: 'Seguimiento Promociones',
//       url: '/reuniones/seguimiento-promociones-list',
//       icon: 'icon-puzzle',
//       roles: ['administrador', 'asesor', 'MAYORISTAMINORISTA']
//     },
//     {
//       name: 'Area influencia',
//       url: '/reuniones/area-influencia',
//       icon: 'icon-puzzle',
//       roles: ['administrador', 'asesor', 'MAYORISTAMINORISTA']
//     },
//   ]
// },
// {
//   name: 'Generales',
//   url: '/generales',
//   icon: 'icon-star',
//   roles: ['administrador', 'asesor', 'MAYORISTAMINORISTA', 'SEGUIMIENTO'],
//   children: [
//     {
//       name: 'Proyectos logrados',
//       url: '/generales/proyectos-logrados',
//       icon: 'icon-puzzle',
//       roles: ['administrador', 'asesor', 'MAYORISTAMINORISTA']
//     },
//     {
//       name: 'Potencial clientes',
//       url: '/generales/potencial-clientes',
//       icon: 'icon-puzzle',
//       roles: ['administrador', 'asesor', 'MAYORISTAMINORISTA']
//     },
//     {
//       name: 'Potencial Segmento ABC',
//       url: '/generales/potencial-contactos-2023',
//       icon: 'icon-puzzle',
//       roles: ['administrador', 'asesor', 'MAYORISTAMINORISTA', 'SEGUIMIENTO']
//     },
//     {
//       name: 'Edades Segmentos',
//       url: '/generales/reporte-edades-segmentos',
//       icon: 'icon-puzzle',
//       roles: ['administrador', 'SEGUIMIENTO']
//     }

//   ]
// },
// {
//   name: 'Promociones',
//   url: '/promociones',
//   icon: 'icon-star',
//   roles: ['administrador', 'asesor', 'MAYORISTAMINORISTA', 'MINORISTA', 'MAYORISTAMINORISTA', 'SEGUIMIENTO'],
//   children: [
//     {
//       name: 'Alta de promocion',
//       url: '/promociones/add',
//       icon: 'icon-puzzle',
//       roles: ['administrador', 'asesor', 'MAYORISTAMINORISTA', 'MINORISTA', 'MAYORISTAMINORISTA', 'SEGUIMIENTO']
//     },
//     {
//       name: 'Listado promociones',
//       url: '/promociones/list',
//       icon: 'icon-puzzle',
//       roles: ['administrador', 'asesor', 'MAYORISTAMINORISTA', 'MINORISTA', 'MAYORISTAMINORISTA', 'SEGUIMIENTO']
//     },
//     {
//       name: "Resumen de Ventas",
//       url: '/promociones/ventas',
//       icon: 'icon-puzzle',
//       roles: ['administrador', 'asesor', 'MAYORISTAMINORISTA', 'MINORISTA', 'MAYORISTAMINORISTA', 'SEGUIMIENTO']
//     },
//     {
//       name: "Control",
//       url: '/promociones/control',
//       icon: 'icon-puzzle',
//       roles: ['administrador', 'asesor', 'MAYORISTAMINORISTA', 'MINORISTA', 'MAYORISTAMINORISTA', 'SEGUIMIENTO']
//     },

//   ]
// },
// {
//   name: 'Seguimiento Contactos',
//   url: '/promociones',
//   icon: 'icon-star',
//   roles: ['administrador', 'asesor', 'MAYORISTAMINORISTA', 'SEGUIMIENTO', 'MINORISTA', 'MAYORISTAMINORISTA'],
//   children: [
//     {
//       name: "Prospectos Pendientes",
//       url: '/promociones/contactos-pendientes',
//       icon: 'icon-puzzle',
//       roles: ['administrador', 'asesor', 'MAYORISTAMINORISTA', 'MINORISTA', 'MAYORISTAMINORISTA', 'SEGUIMIENTO']
//     },
//     {
//       name: "Alta de Contacto",
//       url: '/promociones/contacto/',
//       icon: 'icon-puzzle',
//       roles: ['administrador', 'asesor', 'MAYORISTAMINORISTA', 'MINORISTA', 'MAYORISTAMINORISTA', 'SEGUIMIENTO']
//     },
//     {
//       name: "Contactos",
//       url: '/promociones/contactos',
//       icon: 'icon-puzzle',
//       roles: ['administrador', 'asesor', 'MAYORISTAMINORISTA', 'MINORISTA', 'MAYORISTAMINORISTA', 'SEGUIMIENTO']
//     },
//     {
//       name: 'Alta Fechas ABC',
//       url: '/visitas/abc/add',
//       icon: 'icon-puzzle',
//       roles: ['administrador', 'asesor', 'MAYORISTAMINORISTA', 'SEGUIMIENTO']
//     },
//     {
//       name: 'Fechas ABC',
//       url: '/visitas/a/b/c',
//       icon: 'icon-puzzle',
//       roles: ['administrador', 'asesor', 'MAYORISTAMINORISTA', 'SEGUIMIENTO']
//     },
//     {
//       name: "Contactos por Semana",
//       url: '/promociones/contactos-semana',
//       icon: 'icon-puzzle',
//       roles: ['administrador', 'asesor', 'MAYORISTAMINORISTA', 'SEGUIMIENTO']
//     },
//     {
//       name: 'Eventos',
//       url: '/promociones/eventos',
//       icon: 'icon-puzzle',
//       roles: ['administrador', 'asesor', 'MAYORISTAMINORISTA', 'SEGUIMIENTO']
//     },
//     {
//       name: "Resumen Visitas",
//       url: '/promociones/visitas',
//       icon: 'icon-puzzle',
//       roles: ['administrador', 'asesor', 'MAYORISTAMINORISTA', 'MINORISTA', 'MAYORISTAMINORISTA', 'SEGUIMIENTO']
//     },
//     {
//       name: "Detalle Visitas",
//       url: '/promociones/detalle-visitas',
//       icon: 'icon-puzzle',
//       roles: ['administrador', 'asesor', 'MAYORISTAMINORISTA', 'MINORISTA', 'MAYORISTAMINORISTA', 'SEGUIMIENTO']
//     },
//     {
//       name: "Resultados Formatos",
//       url: '/promociones/resultados-formatos',
//       icon: 'icon-puzzle',
//       roles: ['administrador', 'asesor', 'MAYORISTAMINORISTA', 'MINORISTA', 'MAYORISTAMINORISTA', 'SEGUIMIENTO']
//     },
//     {
//       name: 'Reporte Eventos',
//       url: '/reuniones/eventos-list',
//       icon: 'icon-puzzle',
//       roles: ['administrador', 'asesor', 'MAYORISTAMINORISTA', 'SEGUIMIENTO']
//     },
//     {
//       name: 'Formatos Dinámicos',
//       url: '/promociones/formularios-dinamicos',
//       icon: 'icon-puzzle',
//       roles: ['administrador', 'SEGUIMIENTO']
//     }
//   ]
// },
// {
//   name: 'Minoristas',
//   url: '/minoristas',
//   icon: 'icon-star',
//   roles: ['administrador', 'MINORISTA', 'MAYORISTAMINORISTA'],
//   children: [
//     {
//       name: 'Programación',
//       url: '/visitas/minoristas/list',
//       icon: 'icon-puzzle',
//       roles: ['administrador', 'asesor', 'MAYORISTAMINORISTA', 'MINORISTA', 'MAYORISTAMINORISTA']
//     },
//     {
//       name: "Resumen Ejecutivo",
//       url: '/minoristas',
//       icon: 'icon-puzzle',
//       roles: ['administrador', 'asesor', 'MAYORISTAMINORISTA', 'MINORISTA', 'MAYORISTAMINORISTA']
//     },
//     {
//       name: "Resumen Alcaldías",
//       url: '/minoristas/alcaldias',
//       icon: 'icon-puzzle',
//       roles: ['administrador']
//     }
//   ]
// },
// {
//   name: 'Proyectos',
//   url: '/segmentos',
//   icon: 'icon-star',
//   roles: ['administrador', 'asesor', 'MAYORISTAMINORISTA'],
//   children: [
//     {
//       name: 'Alta Manual',
//       url: '/segmentos/alta-contacto-vist',
//       icon: 'icon-puzzle',
//       roles: ['administrador', 'asesor', 'MAYORISTAMINORISTA']
//     },
//     {
//       name: 'Obras',
//       url: '/segmentos/contactos-list',
//       icon: 'icon-puzzle',
//       roles: ['administrador', 'asesor', 'MAYORISTAMINORISTA']
//     },
//     {
//       name: 'Obras en Proceso',
//       url: '/segmentos/contactos-list-proceso',
//       icon: 'icon-puzzle',
//       roles: ['administrador', 'asesor', 'MAYORISTAMINORISTA']
//     }, {
//       name: 'Importar Inforte',
//       url: '/segmentos/inforte',
//       icon: 'icon-puzzle',
//       roles: ['administrador', 'asesor', 'MAYORISTAMINORISTA']
//     },
//     {
//       name: 'Resumen de Visitas',
//       url: '/segmentos/resumen-ejecutivo',
//       icon: 'icon-puzzle',
//       roles: ['administrador', 'asesor', 'MAYORISTAMINORISTA']
//     },
//     {
//       name: 'Proyectos Semana',
//       url: '/segmentos/proyectos-semana',
//       icon: 'icon-puzzle',
//       roles: ['administrador']
//     },
//     {
//       name: 'Proyectos Convenios',
//       url: '/segmentos/proyectos-convenios',
//       icon: 'icon-puzzle',
//       roles: ['administrador']
//     },
//     {
//       name: 'Proyectos Plan VS Real',
//       url: '/segmentos/proyectos-real-plan',
//       icon: 'icon-puzzle',
//       roles: ['administrador']
//     },
//     {
//       name: 'Consumo Contactos Proyectos',
//       url: '/segmentos/consumo-contactos-proyectos',
//       icon: 'icon-puzzle',
//       roles: ['administrador']
//     },
//     {
//       name: 'Contactos Mayor Consumo',
//       url: '/segmentos/contactos-mayor-consumo',
//       icon: 'icon-puzzle',
//       roles: ['administrador']
//     },
//     {
//       name: 'Gráfica Proyectos en Proceso',
//       url: '/segmentos/reporte-proyectos-proceso-especificacion',
//       icon: 'icon-puzzle',
//       roles: ['administrador', "asesor"]
//     }
//   ]
// },
// {
//   name: 'Redes Subterraneas',
//   url: '/redes-subterraneas',
//   icon: 'icon-star',
//   roles: ['administrador', 'asesor', 'MAYORISTAMINORISTA'],
//   children: [
//     {
//       name: 'Proyectos',
//       url: '/redes-subterraneas/proyectos',
//       icon: 'icon-puzzle',
//       roles: ['administrador', 'asesor', 'MAYORISTAMINORISTA']
//     },
//     {
//       name: 'En proceso',
//       url: '/redes-subterraneas/proyectos/enproceso',
//       icon: 'icon-puzzle',
//       roles: ['administrador', 'asesor', 'MAYORISTAMINORISTA']
//     },
//     {
//       name: 'Resumen de Visitas',
//       url: '/redes-subterraneas/resumen-ejecutivo',
//       icon: 'icon-puzzle',
//       roles: ['administrador', 'asesor']
//     }
//   ]
// }, {
//   name: 'Otros',
//   url: '/otros',
//   icon: 'icon-star',
//   roles: ['administrador', 'asesor', 'MAYORISTAMINORISTA'],
//   children: [
//     {
//       name: 'Programacion Vacaciones',
//       url: '/otros/programacion-vacaciones',
//       icon: 'icon-puzzle',
//       roles: ['administrador', 'asesor', 'MAYORISTAMINORISTA']
//     },
//   ]
// },
{
  name: 'Salir',
  url: '/logout',
  icon: 'icon-close',
  roles: ['administrador', 'asesor', 'MAYORISTAMINORISTA', 'MINORISTA', 'MAYORISTAMINORISTA', 'SEGUIMIENTO']
},
];



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/srd-proinvel-pipeline/src/app/_nav.ts